
import { Component, Vue } from "vue-property-decorator";
import GraphicPageTep from "@/template/graphic/GraphicPage.vue";
@Component
export default class GraphicPage extends GraphicPageTep {}
